export const mock = [
  {
    label: '地图数据',
    id: 'mapData',
    children: [
      {
        label: '数据',
        id: 'map',
        children: [
          {
            label: '停止线',
            id: 'stop_line'
          },
          {
            label: '道路边界',
            id: 'boundary'
          },
          {
            label: '车道线',
            id: 'lane'
          },
          { label: '禁停区', id: 'clear_zone' },
          { label: '人行横道', id: 'cross_walk' },
          { label: '自由停车区', id: 'free_area' },
          { label: '小区门/栏杆', id: 'gate' },
          { label: '路口', id: 'intersection' },
          { label: '停车位', id: 'parking' },
          { label: '柱子/石墩', id: 'pillar' },
          { label: '禁行区', id: 'prohibited_area' },
          { label: '安全岛', id: 'safety_island' },
          { label: '减速带', id: 'speed_bump' },
          { label: '红绿灯', id: 'traffic_light' }
        ]
      },
      { label: '标签', id: 'mapDatalabel' },
      { label: '全量地图', id: 'allMapData' }
    ]
  },
  {
    label: '障碍物数据',
    id: 'obstacleData',
    children: [
      {
        label: '障碍物',
        id: 'obstacle',
        children: [
          { label: '未知物', id: 'misc' },
          { label: '小汽车', id: 'car' },
          { label: '卡车', id: 'truck' },
          { label: '公交车', id: 'bus' },
          { label: '行人', id: 'pedestrian' },
          { label: '自行车，摩托车', id: 'bicycle' },
          { label: '三轮车', id: 'tricycle' },
          { label: '静态元素，比如花坛', id: 'map_point_cluster' },
          { label: '锥桶', id: 'traffic_cone' },
          { label: '低矮障碍物', id: 'low_profile_obstacle' },
          { label: '停放的自行车', id: 'unmanned_bicycle' },
          { label: '虚拟障碍物', id: 'artificial_object' }
        ]
      },

      { label: '标签', id: 'obstacleDatalabel' }
    ]
  }
]
